export default {
  metaTitle: '管理主帐号',
  pageTitle: '管理主帐号',
  tips1: '您将',
  tips2: '账号',
  resetPassword: '重置密码',
  resetAccount: '重置店铺登陆帐号{0}的密码',
  placeholder1: '输入密码',
  tips3: '接受字母，数字，下划线，英文点号,#号',
  placeholder2: '再次输入密码',
  statusType1: '正常',
  statusType2: '锁定',
  columns1: '登录ID',
  columns2: '登录名',
  columns3: '电话',
  columns4: '创建时间',
  columns5: '最近登录时间',
  columns6: '状态',
  columns7: '操作',
  columns8: '重置密码',
  locking1: '锁定',
  locking2: '解锁',
  passwordTips1: '两次密码不一致',
  passwordTips12: '请输入正确的密码',
  error1: '请输入密码',
  error2: '请再次输入密码',

  // EditorAccount
  noAccountTips: '请先填写手机号/邮箱',
  phoneLabel: '手机号',
  emailLabel: '邮箱',
  accountPlaceholder: '输入新手机号/邮箱',
  codePlaceholder: '输入验证码',
  areaPlaceholder: '区号',
  regionPlaceholder: '国家',
  checkContentLabel: '验证内容',
  checkTypeLabel: '验证方式',
  title1Label: '变更为（不变更则不填写）',
  title2Lable: '变更内容',
  okBtnText: '提交变更',
  cancelBtnText: '取消',
  modalTitle: '修改商户账号({0})',
  sendCodeText: '发送',
  editorBtn: '编辑',
  errorNewAccountTips: '请填写正确的{0}',
  noCheckContent: '请验证变更内容',
  noCheckType: '请先验证校验方式',
  noSelectContactError: '请选择校验手机号/邮箱',
  noSelectNewTypeError: '请选择变更内容',
  noCodeError: '请填写验证码',
  curRegionNameLabel: '当前国家：',
  sendCodeOkTips: '验证码发送成功',
  success: '操作成功'
}
